import { render, staticRenderFns } from "./student-document-info.vue?vue&type=template&id=a0509660&scoped=true&"
import script from "./student-document-info.vue?vue&type=script&lang=js&"
export * from "./student-document-info.vue?vue&type=script&lang=js&"
import style0 from "./student-document-info.vue?vue&type=style&index=0&id=a0509660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0509660",
  null
  
)

export default component.exports